import { FC, useState } from "react";
import classes from "./teamDeleteModal.module.scss";
import { ITeam } from "../../../../entities/team";
import { teamService } from "../../../../entities/team";
import { Modal } from "../../../../shared/ui/modal";
import { MyInput } from "../../../../shared/ui/input";
import { MyButton } from "../../../../shared/ui/button";
import { useTeamsCommon } from "../../lib/useTeamsCommon";

interface IProps {
    team: ITeam | null;
    setTeam: (team: ITeam | null) => void;
    onDeleteSuccess: (deletedTeamId: string) => void;
}

export const TeamDeleteModal: FC<IProps> = ({team, setTeam, onDeleteSuccess}) => {
    const [deleteComment, setDeleteComment] = useState('')
    const [deleteError, setDeleteError] = useState('')
    const {setGlobalLoading, handleError, setGlobalMessage} = useTeamsCommon()

    const onDelete = async () => {
        if(!team){
            return
        }

        if(!deleteComment.trim()){
            setDeleteError('Укажите причину архивирования')
            return
        }

        try{
            setGlobalLoading(true)
            await teamService.delete(team.id, deleteComment.trim())
            const deletedTeamId = team.id
            setTeam(null)
            setDeleteComment('')
            setDeleteError('')
            setGlobalMessage({message: 'Звено успешно архивировано', type: 'ok'})
            onDeleteSuccess(deletedTeamId)
        }
        catch(e){
            handleError(e, 'Ошибка при архивировании звена')
        }
        finally{
            setGlobalLoading(false)
        }
    }

    return (
        <Modal open={Boolean(team)} setOpen={(open) => {
            if(!open){
                setTeam(null)
                setDeleteComment('')
                setDeleteError('')
            }
        }}>
            <section className={classes.deleteModal}>
                <section className={classes.modalTitle}>Архивировать звено</section>
                <section className={classes.deleteText}>
                    Укажите причину архивирования звена. Исторические данные сохранятся, но звено исчезнет из будущего планирования.
                </section>
                <MyInput
                    title="Причина"
                    value={deleteComment}
                    setValue={setDeleteComment}
                    setError={setDeleteError}
                    error={deleteError}
                    placeholder="Например: реорганизация состава"
                />
                <section className={classes.formActions}>
                    <MyButton onClick={onDelete} error={deleteError}>Архивировать</MyButton>
                </section>
            </section>
        </Modal>
    )
}
